import { styled } from "@mui/material";

export const MainContainer = styled("main")({
  width: "100%",
  height: "auto",
});

export const ComponentContainer = styled("div")(({ theme }) => ({
  paddingTop: "65px",
  width: "100%",
  display: "flex",
  height: "100vh",
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

export const ContentContainer = styled("div")(({ theme }) => ({
  width: "100%",
  padding: "40px 50px",
  overflowY: "auto",
  flexGrow: 1,
  [theme.breakpoints.down("lg")]: {
    padding: "40px 50px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "20px 16px",
  },
}));
